
export const SITE_URL = 'https://hrisapi.pentasi.net/';
// export const SITE_URL = 'http://127.0.0.1:8300/';
export const BASE_URL = SITE_URL+'api/v1/';

export const APP_VERSION = '0.1.2'
